import { toast, ToastContent, ToastOptions } from 'react-toastify';

class ToastService {
  private static _instance: ToastService;

  static getInstance(): ToastService {
    if (!this._instance) {
      this._instance = new ToastService();
    }
    return this._instance;
  }

  showSuccess(content: ToastContent, config?: ToastOptions) {
    toast.dismiss();
    toast(content, {
      ...config,
      type: 'success',
      position: config?.position ?? 'top-center',
      autoClose: config?.autoClose ?? 2000,
    });
  }

  showWarning(content: ToastContent, config?: ToastOptions) {
    toast.dismiss();
    toast(content, {
      ...config,
      type: 'warning',
      position: config?.position ?? 'top-center',
      autoClose: config?.autoClose ?? false, // By default warning toast messages wont auto close
      style: { backgroundColor: 'white', border: '1px solid red' },
    });
  }

  showError(content: ToastContent, config?: ToastOptions) {
    toast.dismiss();
    toast(content, {
      ...config,
      type: 'error',
      position: config?.position ?? 'top-center',
      autoClose: config?.autoClose ?? false, // By default error toast messages wont auto close
      style: { backgroundColor: '#FDF2F2' },
    });
  }

  dismiss(toastRef: any) {
    toast.dismiss(toastRef);
  }
}

export const toastService = ToastService.getInstance();
